import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { ObjectUtils } from "../util/ObjectUtils";
import { TypeORMError } from "../error";
/**
 */
export var Alias = /*#__PURE__*/function () {
  function Alias(alias) {
    _classCallCheck(this, Alias);
    ObjectUtils.assign(this, alias || {});
  }
  _createClass(Alias, [{
    key: "target",
    get: function get() {
      return this.metadata.target;
    }
  }, {
    key: "hasMetadata",
    get: function get() {
      return !!this._metadata;
    }
  }, {
    key: "metadata",
    get: function get() {
      if (!this._metadata) throw new TypeORMError("Cannot get entity metadata for the given alias \"".concat(this.name, "\""));
      return this._metadata;
    },
    set: function set(metadata) {
      this._metadata = metadata;
    }
  }]);
  return Alias;
}();